import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import store from './store/Store';
import { Provider } from 'react-redux';
import HomePage from './page/HomePage';
import NewsListPage from './page/NewsListPage';
import NewsDetailPage from './page/NewsDetailPage';
import AboutUsPage from './page/AboutUsPage';
import ContactPage from './page/ContactPage';
import RecruitPage from './page/RecruitPage';
import PolicyPage from './page/PolicyPage';
import PrivacyPage from './page/PrivacyPage';
import LoadingAndHint from './component/LoadingAndHint';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='*' element={<HomePage />} />
        <Route path='/newsList' element={<NewsListPage />} />
        <Route path='/newsDetail' element={<NewsDetailPage />} />
        <Route path='/about' element={<AboutUsPage />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/recruit' element={<RecruitPage />} />
        <Route path='/policy' element={<PolicyPage />} />
        <Route path='/privacy' element={<PrivacyPage />} />
      </Routes>
      <LoadingAndHint/>
    </BrowserRouter>
  </Provider>
);
